/*=========================================================================================
  File Name: module-taxpapertax.js
  Description: taxpaperTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-settingnoti-state';
import mutations from './module-settingnoti-mutations';
import actions from './module-settingnoti-actions';
import getters from './module-settingnoti-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
